import React, { useState, useEffect, useCallback, useContext } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import RadioGroup from "@mui/material/RadioGroup";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import Login1UnderlineCircle from "../../assets/login1-underline-circle.png";
import Login1OutlineCircle from "../../assets/login1-outline-circle.png";
import Login1UnderlineFullSize from "../../assets/login1-underline-full-size.png";
import Login1OutlineFullSize from "../../assets/login1-outline-full-size.png";

import Login1UnderlineCircleLogo from "../../assets/login1-underline-circle-logo.png";
import Login1OutlineCircleLogo from "../../assets/login1-outline-circle-logo.png";
import Login1UnderlineFullSizeLogo from "../../assets/login1-underline-full-size-logo.png";
import Login1OutlineFullSizeLogo from "../../assets/login1-outline-full-size-logo.png";

import Login1FilledCircleLogo from "../../assets/login1-filled-circle-logo.png";
import Login1FilledCircle from "../../assets/login1-filled-circle.png";
import Login1FilledFullSizeLogo from "../../assets/login1-filled-full-size-logo.png";
import Login1FilledFullSize from "../../assets/login1-filled-full-size.png";

import Login1UnderlineCircleCard from "../../assets/login1-underline-circle-card.png";
import Login1OutlineCircleCard from "../../assets/login1-outline-circle-card.png";
import Login1UnderlineFullSizeCard from "../../assets/login1-underline-full-size-card.png";
import Login1OutlineFullSizeCard from "../../assets/login1-outline-full-size-card.png";

import Login1UnderlineCircleLogoCard from "../../assets/login1-underline-circle-logo-card.png";
import Login1OutlineCircleLogoCard from "../../assets/login1-outline-circle-logo-card.png";
import Login1UnderlineFullSizeLogoCard from "../../assets/login1-underline-full-size-logo-card.png";
import Login1OutlineFullSizeLogoCard from "../../assets/login1-outline-full-size-logo-card.png";

import Login1FilledCircleLogoCard from "../../assets/login1-filled-circle-logo-card.png";
import Login1FilledCircleCard from "../../assets/login1-filled-circle-card.png";
import Login1FilledFullSizeLogoCard from "../../assets/login1-filled-full-size-logo-card.png";
import Login1FilledFullSizeCard from "../../assets/login1-filled-full-size-card.png";

import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import { Alert, CircularProgress } from "@mui/material";
import { UserContext } from "../../context/UserContext";

import { useTranslation } from "react-i18next";
import { useAlert } from "react-alert";

import EmptyIphone from "../../assets/iphone-empty.png";

import Tabbar from "../../assets/tabbar-ios.png";
import TabbarServices from "../../assets/tabbar-ios-services.png";

const useStyles = makeStyles({
	iphoneContainer: {
		"& *": {
			userDrag: "none",
		},
	},
	iphone: {
		width: 260,
		padding: 20,
		paddingTop: 0,
	},
	cardInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardPageInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardOptions: {
		display: "flex",
		flexDirection: "column",
	},
	cardForm: {
		display: "flex",
	},
	cardGrid: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
});

const logins = [
	{
		value: "login1",
		label: (
			<>
				<b>Style 1</b>:
			</>
		),
	},
	{
		value: "login2",
		label: (
			<>
				<b>Style 2</b>:
			</>
		),
	},
];

export default function Authentication({ drawerWidth }) {
	const classes = useStyles();
	const [login, setLogin] = useState(null);
	const [loading, setLoading] = useState(false);
	const [showLogo, setShowLogo] = useState(false);
	const [inputType, setInputType] = useState("");
	const [socialType, setSocialType] = useState("");
	const [loginTitle, setLoginTitle] = useState("");
	const [loginCard] = useState(false);
	const [loginBorderCard, setLoginBorderCard] = useState(false);
	const { user } = useContext(UserContext);
	const { t } = useTranslation();
	const alert = useAlert();

	const getLoginData = async () => {
		setLoading(true);
		try {
			const res = await axios.get(ADMIN_URL + "creators", {
				headers: { authorization: localStorage.getItem("token") },
			});
			setLogin(
				logins.find((login) => {
					return login.value === res.data.loginType;
				})
			);
			setInputType(res.data.inputType);
			setSocialType(res.data.socialButtonType);
			setShowLogo(res.data.logoOnLogin);
			setLoginTitle(res.data.loginTitle);
			setLoginBorderCard(res.data.loginBorder);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	useEffect(() => {
		getLoginData();
	}, []);

	const saveLoginData = async () => {
		setLoading(true);
		try {
			await axios.post(
				ADMIN_URL + "creators",
				{
					loginType: login.value,
					inputType: inputType,
					socialButtonType: socialType,
					logoOnLogin: showLogo,
					loginTitle: loginTitle,
					loginBorder: loginBorderCard,
					loginCard: loginCard,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			alert.show(t("general.success"), { type: "success" });
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	return (
		<Box
			component="main"
			sx={{
				flexGrow: 1,
				bgcolor: "background.default",
				p: 3,
				width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
			}}
		>
			<Toolbar />
			<Alert
				severity="info"
				sx={{
					marginBottom: 2,
				}}
				className={classes.alert}
			>
				{t("auth.socialWarn")}
			</Alert>
			<Card variant="outlined">
				<>
					<CardContent>
						<Typography
							sx={{
								fontSize: 14,
								borderBottom: "1px solid #f0f0f0",
								minHeight: "35px",
								marginBottom: "20px",
								marginLeft: "-20px",
								marginRight: "-20px",
								padding: "0px 20px 20px",
							}}
							color="text.secondary"
							gutterBottom
						>
							{t("auth.title")}
						</Typography>
						<Box
							className={classes.cardPageInfo}
							sx={{
								flexFlow: {
									xs: "column-reverse",
									sm: "column-reverse",
									md: "row",
								},
							}}
						>
							<Box
								className={classes.cardOptions}
								sx={{
									minWidth: {
										xs: 0,
										sm: 0,
										md: 400,
									},
								}}
							>
								<Typography
									sx={{
										fontSize: 12,
										marginTop: 2,
										marginBottom: 0,
										fontWeight: 700,
										textTransform: "uppercase",
									}}
									color="text.secondary"
									gutterBottom
								>
									{t("auth.showCardType")}
								</Typography>
								<FormControlLabel
									control={
										<Checkbox
											checked={loginBorderCard && loginBorderCard}
											onChange={(e) => {
												setLoginBorderCard(!loginBorderCard);
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									}
									label={t("auth.showBorder2")}
								/>

								<Typography
									sx={{
										fontSize: 12,
										marginTop: 2,
										marginBottom: 0,
										fontWeight: 700,
										textTransform: "uppercase",
									}}
									color="text.secondary"
									gutterBottom
								>
									{t("auth.chooseLogo")}
								</Typography>
								<FormControlLabel
									control={
										<Checkbox
											checked={showLogo && showLogo}
											onChange={(e) => {
												setShowLogo(!showLogo);
											}}
											disabled={[
												"building",
												"built",
												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									}
									label={t("auth.showLogo")}
								/>
								<Typography
									sx={{
										fontSize: 12,
										marginTop: 2,
										marginBottom: 0,
										fontWeight: 700,
										textTransform: "uppercase",
									}}
									color="text.secondary"
									gutterBottom
								>
									{t("auth.chooseInput")}
								</Typography>
								<RadioGroup
									aria-labelledby=""
									value={inputType}
									name="radio-buttons-group"
									onChange={(e) => {
										setInputType(e.target.value);
									}}
								>
									<FormControlLabel
										key={"input1"}
										value={"input1"}
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("auth.underline")}
									/>
									<FormControlLabel
										key={"input2"}
										value={"input2"}
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("auth.outlined")}
									/>
									<FormControlLabel
										key={"input3"}
										value={"input3"}
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("auth.filled")}
									/>
								</RadioGroup>
								<Typography
									sx={{
										fontWeight: 500,
										fontSize: 11,
										marginTop: 1,
										maxWidth: 300,
									}}
								>
									{"*" + t("auth.inputInfo")}
								</Typography>
								<Typography
									sx={{
										fontSize: 12,
										marginTop: 2,
										marginBottom: 0,
										fontWeight: 700,
										textTransform: "uppercase",
									}}
									color="text.secondary"
									gutterBottom
								>
									{t("auth.chooseSocial")}
								</Typography>
								<RadioGroup
									aria-labelledby=""
									value={socialType}
									name="radio-buttons-group"
									onChange={(e) => {
										setSocialType(e.target.value);
									}}
								>
									<FormControlLabel
										key={"socialButton1"}
										value={"socialButton1"}
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("auth.circle")}
									/>
									<FormControlLabel
										key={"socialButton2"}
										value={"socialButton2"}
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("auth.fullSize")}
									/>
								</RadioGroup>
								<FormControl
									fullWidth
									variant="standard"
									sx={{ marginTop: 4, marginBottom: 2 }}
								>
									<InputLabel
										shrink
										htmlFor="app-name-input"
										sx={{
											marginTop: -2,
											fontWeight: 700,
											textTransform: "uppercase",
											fontSize: 12,
										}}
									>
										{t("auth.signInTitle")}
									</InputLabel>
									<TextField
										id="app-name-input"
										fullWidth
										variant="outlined"
										value={loginTitle}
										onChange={(e) => {
											setLoginTitle(e.target.value);
										}}
										disabled={[
											"building",
											"built",

											"publishing",
											"published",
											"inviting",
										].find(
											(status) =>
												status ===
												(user.app.appStatuses.length === 0
													? ""
													: user.app.appStatuses.length > 0 &&
													  user.app.appStatuses[0].status)
										)}
									/>
								</FormControl>
							</Box>
							<div
								className={classes.iphoneContainer}
								style={{ position: "relative" }}
							>
								<img
									src={
										login
											? loginBorderCard
												? inputType === "input1" &&
												  socialType === "socialButton1"
													? showLogo === true
														? Login1UnderlineCircleLogoCard
														: Login1UnderlineCircleCard
													: inputType === "input1" &&
													  socialType === "socialButton2"
													? showLogo === true
														? Login1UnderlineFullSizeLogoCard
														: Login1UnderlineFullSizeCard
													: inputType === "input2" &&
													  socialType === "socialButton1"
													? showLogo === true
														? Login1OutlineCircleLogoCard
														: Login1OutlineCircleCard
													: inputType === "input2" &&
													  socialType === "socialButton2"
													? showLogo === true
														? Login1OutlineFullSizeLogoCard
														: Login1OutlineFullSizeCard
													: inputType === "input3" &&
													  socialType === "socialButton1"
													? showLogo === true
														? Login1FilledCircleLogoCard
														: Login1FilledCircleCard
													: inputType === "input3" &&
													  socialType === "socialButton2"
													? showLogo === true
														? Login1FilledFullSizeLogoCard
														: Login1FilledFullSizeCard
													: null
												: inputType === "input1" &&
												  socialType === "socialButton1"
												? showLogo === true
													? Login1UnderlineCircleLogo
													: Login1UnderlineCircle
												: inputType === "input1" &&
												  socialType === "socialButton2"
												? showLogo === true
													? Login1UnderlineFullSizeLogo
													: Login1UnderlineFullSize
												: inputType === "input2" &&
												  socialType === "socialButton1"
												? showLogo === true
													? Login1OutlineCircleLogo
													: Login1OutlineCircle
												: inputType === "input2" &&
												  socialType === "socialButton2"
												? showLogo === true
													? Login1OutlineFullSizeLogo
													: Login1OutlineFullSize
												: inputType === "input3" &&
												  socialType === "socialButton1"
												? showLogo === true
													? Login1FilledCircleLogo
													: Login1FilledCircle
												: inputType === "input3" &&
												  socialType === "socialButton2"
												? showLogo === true
													? Login1FilledFullSizeLogo
													: Login1FilledFullSize
												: EmptyIphone
											: EmptyIphone
									}
									alt="iphone"
									onMouseOver={() => {}}
									onMouseLeave={() => {}}
									className={classes.iphone}
								/>
								<img
									src={
										user.app.appType === "Services" ? TabbarServices : Tabbar
									}
									alt="tabbar"
									onMouseOver={() => {}}
									onMouseLeave={() => {}}
									className={classes.iphone}
									style={{ position: "absolute", top: 0, left: 0 }}
								/>
								<div
									style={{
										position: "absolute",
										top: 30,
										left: 35,
										backgroundColor: "white",
										width: 20,
										height: 20,
									}}
								></div>
								{user.app.appType === "Woocommerce" && (
									<div
										style={{
											position: "absolute",
											top:
												loginBorderCard && !showLogo
													? 245 + (inputType === "input2" ? 25 : 0)
													: 280 + (inputType === "input2" ? 20 : 0),
											left: 42,
											width: 178,
											backgroundColor: "white",
											height: 60 + +(socialType === "socialButton2" ? 20 : 0),
										}}
									></div>
								)}
							</div>
						</Box>
					</CardContent>
					{!["inviting", "building", "built", "publishing", "published"].find(
						(status) =>
							status ===
							(user.app.appStatuses.length === 0
								? ""
								: user.app.appStatuses.length > 0 &&
								  user.app.appStatuses[0].status)
					) && (
						<CardActions sx={{ justifyContent: "right" }}>
							<Button
								variant="contained"
								onClick={() => {
									saveLoginData();
								}}
								size="small"
								disabled={loading}
							>
								{loading ? <CircularProgress size={12} /> : t("general.save")}
							</Button>
						</CardActions>
					)}
				</>
			</Card>
		</Box>
	);
}
